var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.value)?_c('span',{staticClass:"bg-green-100 text-green-800 text-xs font-semibold mr-2 px-2.5 py-0.5 rounded"},[_vm._v("Oui")]):_vm._e(),(!_vm.value)?_c('span',{staticClass:"bg-red-100 text-red-800 text-xs font-semibold mr-2 px-2.5 py-0.5 rounded"},[_vm._v("Non")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }